<template>
  <div>
    <div class="col-md-12">
      <h1 class="h3 mb-3 text-gray-800">
        Relatório RMA - Registro Mensal de Atendimentos
      </h1>
    </div>

    <div class="row m-3 p-0 alert alert-info">
      <div class="col-md-4 col-sm-12 d-flex align-items-stretch">
        <a
          :href="`${urlbase}manual/Manual RMA - Unidade_ CENTRO POP - 2026 - Validado (agosto).pdf`"
          target="_blank"
          class="card card-body mb-0 row"
        >
          <div class="row d-flex align-items-center">
            <div class="col-4">
              <img
                :src="`${urlbase}img/files/pdf.svg`"
                alt="MANUAL RMA CENTRO POP 2026"
                width="100"
              />
            </div>
            <div class="col-8">MANUAL RMA CENTRO POP 2026</div>
          </div>
        </a>
      </div>
      <div class="col-md-4 col-sm-12 d-flex align-items-stretch">
        <a
          :href="`${urlbase}manual/Manual RMA - Unidade_ CREAS - 2026.pdf`"
          target="_blank"
          class="card card-body mb-0 row"
        >
          <div class="row d-flex align-items-center">
            <div class="col-4">
              <img
                :src="`${urlbase}img/files/pdf.svg`"
                alt="MANUAL RMA CREAS 2026"
                width="100"
              />
            </div>
            <div class="col-8">MANUAL RMA CREAS 2026</div>
          </div>
        </a>
      </div>
      <div class="col-md-4 col-sm-12 d-flex align-items-stretch">
        <a
          :href="`${urlbase}manual/Manual RMA  - Unidade_ CRAS - 2026.pdf`"
          target="_blank"
          class="card card-body mb-0 row"
        >
          <div class="row d-flex align-items-center">
            <div class="col-4">
              <img
                :src="`${urlbase}img/files/pdf.svg`"
                alt="MANUAL RMA CRAS 2026"
                width="100"
              />
            </div>
            <div class="col-8">MANUAL RMA CRAS 2026</div>
          </div>
        </a>
      </div>
    </div>

    <div class="col-md-12">
      <div class="card mb-0 shadow">
        <div class="card-body">
          <load
            mode="table"
            v-if="loadingForm"
            message="Carregando os registros mensais de atendimentos"
          />
          <form v-else @submit.prevent="submit">
            <div class="row">
              <form-select
                :grid="
                  tipo != 'socioassistencial' && tipo != 'gestor' ? '2' : '6'
                "
                label="Tipo"
                :itens="tipos"
                v-model="tipo"
                :disabled="!edit"
                :required="true"
                @change="mudarUnidades"
              />
              <form-select
                v-if="tipo != 'socioassistencial' && tipo != 'gestor'"
                :grid="periodo != 'Anual' ? '4' : '6'"
                label="Unidade"
                :itens="unidadesByTipo"
                v-model="unidadeSelected"
                :disabled="!edit"
                :required="true"
                :multiple="true"
                @change="definirUnidades"
              />
              <form-select
                grid="2"
                label="Periodo"
                :itens="periodos"
                v-model="periodo"
                :disabled="!edit"
                :required="true"
              />
              <form-select
                grid="2"
                label="Ano"
                :itens="anos"
                v-model="ano"
                :disabled="!edit"
                :required="true"
                @change="mudarAnos"
              />
              <form-select
                v-if="periodo != 'Anual'"
                grid="2"
                label="Mês"
                :itens="meses"
                v-model="mes"
                :disabled="!edit"
                :required="true"
              />
            </div>
            <div class="row pt-4 px-0 d-flex justify-content-end">
              <div class="col-auto px-2 text-right" v-if="loading == false">
                <a class="btn btn-default" @click="redirectRelatorios">
                  <i class="mdi mdi-arrow-left" />
                </a>
                <a
                  v-if="is_result"
                  class="btn btn-primary"
                  @click="print"
                  :title="$t('Imprimir')"
                  v-b-tooltip.hover
                >
                  <i class="mdi mdi-printer" />
                </a>
                <a
                  v-if="is_result"
                  class="btn btn-primary"
                  @click="exportar()"
                  :title="$t('Exportar')"
                  v-b-tooltip.hover
                >
                  <i class="fas fa-file-excel" />
                </a>
                <a
                  v-if="is_result && tipo == 'cras' && unidadeSelected.length == 1"
                  class="btn btn-primary"
                  @click="gerarXML()"
                  :title="$t('Gerar XML')"
                  v-b-tooltip.hover
                >
                  <i class="fas fa-file-code" />
                </a>
                <button
                  v-if="is_result && rmaId"
                  class="btn btn-info"
                  @click="$bvModal.show('status-envio-mds-modal')"
                >
                  {{ $t("Registrar Status MDS") }}
                </button>
                <button v-if="is_result" class="btn btn-danger" @click="limpar">
                  {{ $t("Limpar filtros") }}
                </button>
                <button
                  
                  class="btn btn-success btn-submit"
                  data-style="zoom-in"
                  type="submit"
                  v-b-tooltip.hover
                  :title="$t('Antes de gerar o relatório, consulte no histórico se já existe um relatório gerado para o mesmo período.')"
                >
                  {{ $t("Gerar relatório") }}
                </button>
                <a
                  class="btn btn-info"
                  @click="verHistorico"
                  :title="$t('Ver histórico de relatórios')"
                  v-b-tooltip.hover
                >
                  <i class="mdi mdi-history" />
                </a>
              </div>
            </div>
          </form>
          <load mode="table" v-if="loading" message="Carregando relatório..." />
          <div v-else class="row">
            <div id="boxPrint" class="col-12 px-0">
              <Header
                :dados="result"
                :unidade="unidadeSelected"
                :relatorio="relatorioSelected"
                :mes="mes"
                :ano="ano"
                :periodo="periodo"
                :unidades="unidadesSelecionadas"
              />
              <Cras
                v-if="tipo == 'cras' && show"
                :unidade="unidadeSelected"
                :mes="mes"
                :ano="ano"
                :periodo="periodo"
                :dados="result"
              />
              <Creas
                v-if="tipo == 'creas' && show"
                :mes="mes"
                :ano="ano"
                :periodo="periodo"
                :dados="result"
              />
              <CentroPop
                v-if="tipo == 'centro pop' && show"
                :mes="mes"
                :ano="ano"
                :periodo="periodo"
                :dados="result"
              />
              <Socioassistencial
                v-if="tipo == 'socioassistencial' && show"
                :mes="mes"
                :ano="ano"
                :periodo="periodo"
                :dados="result"
              />
              <Gestor
                v-if="tipo == 'gestor' && show"
                :mes="mes"
                :ano="ano"
                :periodo="periodo"
                :dados="result"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <StatusEnvioMds v-if="rmaId" :rma-id="rmaId" />
  </div>
</template>
<script>
import Cras from "./includes/CRAS";
import Creas from "./includes/CREAS";
import Gestor from "./includes/Gestor";
import CentroPop from "./includes/CentroPop";
import Socioassistencial from "./includes/Socioassistencial";
import Header from "./includes/Header";
import StatusEnvioMds from "./includes/StatusEnvioMds.vue";
export default {
  components: {
    Cras,
    Creas,
    Gestor,
    CentroPop,
    Socioassistencial,
    Header,
    StatusEnvioMds,
  },
  props: [],
  name: "Add",
  data() {
    return {
      tipo: "",
      unidadeSelected: [],
      periodo: "Mensal",
      mes: "",
      ano: "",
      result: [],
      is_result: false,
      periodos: [
        { id: "Mensal", value: "Mensal" },
        { id: "Anual", value: "Anual" },
      ],
      meses_ano: "",
      meses: [],
      relatorioSelected: [],
      meses_temp: [],
      anos: [],
      anos_temp: [],
      anoInicialFinal: "",
      unidades: [],
      unidadesByTipo: [],
      unidadesSelecionadas: "",
      tipos: [
        { id: "cras", value: "CRAS" },
        { id: "creas", value: "CREAS" },
        { id: "centro pop", value: "Centro POP" },
        { id: "gestor", value: "Gestor" },
        {
          id: "socioassistencial",
          value: "Vigilância Socioassistencial",
        },
      ],
      show: false,
      loadingForm: true,
      loading: false,
      edit: true,
      alert: "",
      urlbase: window.urlbase,
      rmaId: null,
    };
  },
  mounted() {
    this.getUnidades();
    this.getAtendimentosAnos();
    if (this.$route.query.tipo && this.$route.query.tipo == "gestor") {
      this.tipo = "gestor";
    }
  },

  methods: {
    exportar() {
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .post(`api/dashboard/relatorio/rma/export`, {
          tipo: this.tipo,
          unidade: this.unidadeSelected,
          periodo: this.periodo,
          mes: this.mes,
          ano: this.ano,
        })
        .then((response) => {
          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        });
    },
    gerarXML() {
      if (this.unidadeSelected.length > 1) {
        swal.fire({
          title: "Erro!",
          text: "Para gerar o XML selecione apenas uma unidade.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      if (this.periodo == "Anual") {
        swal.fire({
          title: "Erro!",
          text: "Para gerar o XML selecione o período Mensal.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .post(`api/dashboard/relatorio/rma/xml`, {
          tipo: this.tipo,
          unidade: this.unidadeSelected,
          periodo: this.periodo,
          mes: this.mes,
          ano: this.ano,
        })
        .then((response) => {
          this.downloadFile(response.data.link, "XML");
          this.rmaId = response.data.xml.id;
          swal.fire({
            title: "Orientações para Upload do Arquivo XML no Portal MDS",
            html: `
            <ol style="text-align: left; display: flex; flex-direction: column; gap: 0.5rem; margin-top: 1rem;">
                <li><strong>Acesse o sistema do RMA</strong> no <a href="https://aplicacoes.mds.gov.br/sagi/atendimento/auth/index.php" target="_blank">Portal do MDS</a> com seu login e senha.</li>
                <li><strong>Selecione o mês e o ano</strong> de referência do registro.</li>
                <li>Clique em <strong>"Importar arquivo XML"</strong>.</li>
                <li><strong>Selecione o arquivo</strong> gerado pelo SUAS Fácil (ex.: <code>rma_cras_2025_03.xml</code>) e clique em <strong>"Enviar"</strong>.</li>
                <li><strong>Aguarde a validação</strong> automática do arquivo no Portal MDS.</li>
                <li>Após o envio bem-sucedido, o sistema exibirá uma mensagem de confirmação indicando que o arquivo foi recebido. <strong>Guarde esse comprovante para seus registros.</strong></li>
                <li>Volte para esta tela e clique em <strong>"Registrar Status MDS"</strong>.</li>
                <li>No modal que abrir, preencha o <strong>Status de Envio</strong> (Sucesso ou Erro) e a <strong>Data de Envio</strong>.</li>
                <li>Se o envio apresentou erro, utilize o campo <strong>Observações</strong> para detalhar o problema.</li>
                <li>Clique em <strong>"Salvar Status"</strong> para registrar o envio no sistema local.</li>
            </ol>
            `,
            icon: "success",
            showConfirmButton: true,
            confirmButtonText: "OK",
            width: "600px",
          });
        })
        .catch((error) => {
          this.handleApiError(error, "Erro ao gerar o arquivo XML.");
        });
    },
    downloadFile(url, fileType) {
      const link = document.createElement("a");
      link.href = url;
      link.download = "";

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);

      swal.fire({
        title: "Arquivo Baixado com Sucesso!",
        text: `O arquivo ${fileType} foi baixado para seus downloads.`,
        icon: "success",
        timer: 3000,
        showConfirmButton: false,
      });
    },
    handleApiError(error, defaultMessage = "Ocorreu um erro inesperado.") {
      console.error("Erro completo:", error);

      let errorMessage = defaultMessage;
      let errorHtml = null;

      let title = 'Erro ao gerar XML!'
      let icon = 'error'

      if (error.response) {
        if (error.response.data) {
          // Padrão Laravel: { message: "erro" }
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
          // Padrão alternativo: { error: "erro" }
          else if (error.response.data.error) {
            errorMessage = error.response.data.error;
          }
          // Erros de validação Laravel: { errors: { field: ["erro1", "erro2"] } }
          else if (error.response.data.errors) {
            title = 'Ajuste os seguintes pontos para gerar o XML!'
            icon = 'warning'
            const errors = Object.values(error.response.data.errors).flat();
            errorHtml = `<ul style="text-align:left; margin:0; padding-left:1.2rem;">${errors
              .map((message) => `<li>${message}</li>`)
              .join("")}</ul>`;
            errorMessage = errors.join("\n");
          }
          // Resposta em string simples
          else if (typeof error.response.data === "string") {
            errorMessage = error.response.data;
          }
          // Para debug - mostrar estrutura completa se não encontrar padrão conhecido
          else {
            console.warn(
              "Estrutura de erro não reconhecida:",
              error.response.data
            );
          }
        }
      } else if (error.request) {
        errorMessage =
          "Erro de conexão. Verifique sua internet e tente novamente.";
      }
      // Erro na configuração da requisição
      else {
        errorMessage = error.message || defaultMessage;
      }

      // Exibir erro para o usuário
      swal.fire({
        title,
        icon,
        confirmButtonText: "OK",
        ...(errorHtml ? { html: errorHtml } : { text: errorMessage }),
      });

      return errorMessage;
    },
    limpar() {
      this.edit = true;
      this.loading = false;
      this.show = false;
      this.is_result = false;
      this.tipo = "";
      this.unidadeSelected = "";
      this.periodo = "Mensal";
      this.mes = "";
      this.ano = "";
      this.result = [];
      this.relatorioSelected = [];
      this.anos = this.anos_temp;
    },
    mudarAnos() {
      const result = this.meses_ano.filter((item) => item.id == this.ano);
      this.edit = false;
      this.meses = [];
      const meses_ano = result.map((elem) => ({
        id: this.meses_temp.filter((item) => item.id == elem.value)[0].id,
        value: this.meses_temp.filter((item) => item.id == elem.value)[0].value,
      }));

      this.meses = meses_ano;
      this.edit = true;
    },
    mudarUnidades() {
      if (this.tipo != "socioassistencial" && this.tipo != "gestor") {
        this.unidadeSelected = "";
        this.unidadesByTipo = this.unidades.filter(
          (item) => item.tipo == this.tipo
        );
      }
    },
    definirUnidades() {
      this.unidade = this.unidadeSelected;
      this.unidadesSelecionadas = this.unidades
        .filter((item) => this.unidadeSelected.includes(item.id))
        .map(
          (item) =>
            `<span class="badge bg-light text-dark border">${item.value}</span> `
        )
        .join("");
    },
    getTipos() {
      axios
        .post("api/dashboard/admin/getTipos", {
          model: "Unidade",
          module: "Unidade",
        })
        .then((response) => {
          this.setTipos(response.data.data);
        });
    },
    setTipos(data) {
      this.tipos = data.map((elem) => ({
        id: elem.id,
        value: elem.descricao,
      }));
    },
    getUnidades() {
      axios.get(`api/dashboard/unidades/get/externas/rma`).then((response) => {
        this.unidades = this.unidadesByTipo = response.data;
      });
    },
    getAtendimentosAnos() {
      this.loadingForm = true;
      axios
        .get(`api/dashboard/relatorio/get/anos`)
        .then((response) => {
          this.anos = response.data.anos;
          this.anos_temp = response.data.anos;
          this.meses = response.data.meses;
          this.meses_temp = response.data.meses;
          this.meses_ano = response.data.meses_ano;
          this.meses_ano_temp = response.data.meses_ano;
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
    verHistorico() {
      this.$router.push("/dashboard/relatorio/RMA/historico");
    },
    submit() {
      this.edit = false;
      this.is_result = false;
      this.loading = true;
      this.alert = "";
      this.result = [];
      axios
        .post(`api/dashboard/relatorio/rma`, {
          tipo: this.tipo,
          unidade: this.unidadeSelected,
          periodo: this.periodo,
          mes: this.mes,
          ano: this.ano,
        })
        .then((response) => {
          this.show = true;
          this.is_result = true;
          this.result = response.data;
          if (this.result.length <= 0) {
            this.alert =
              '<div class="alert alert-warning">Nenhum resultado foi encontrado.</div>';
          }
        })
        .finally(() => {
          this.loading = false;
          this.edit = true;
        });
    },
    print() {
      const modal = document.getElementById("boxPrint");
      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");

      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
    },
    redirectRelatorios() {
      this.$router.push(`/dashboard/relatorios`);
    },
  },
};
</script>
